import outwardServiceervice from "../../services/outWardService";
import {
      OUTWARD_GET_CATEGORY_ATTRIBUTE_FAILURE,
      OUTWARD_GET_CATEGORY_ATTRIBUTE_REQUEST,
      OUTWARD_GET_CATEGORY_ATTRIBUTE_SUCCESS,
      OUTWARD_GET_CATEGORY_FAILURE,
      OUTWARD_GET_CATEGORY_REQUEST,
      OUTWARD_GET_CATEGORY_SUCCESS
     } from "./actionTypes";



export const fetchcategory = (marketPlaceName,requestBody,token) => {
 
    return async (dispatch) => {
      dispatch({ type: OUTWARD_GET_CATEGORY_REQUEST });
      try {
        const response = await outwardServiceervice.fetchCategory(marketPlaceName,requestBody,token);
      
        dispatch({ type: OUTWARD_GET_CATEGORY_SUCCESS, payload: response });
        return data; 
      } catch (error) {
        dispatch({ type: OUTWARD_GET_CATEGORY_FAILURE, error: error.message });
        return Promise.reject(error); 
      }
    };
  };


  export const fetchcategoryAttribute = (marketPlaceName,requestBody,token) => {
   
    return async (dispatch) => {
      dispatch({ type: OUTWARD_GET_CATEGORY_ATTRIBUTE_FAILURE });
      try {
        const response = await outwardServiceervice.fetchCategoryAttribute(marketPlaceName,requestBody,token);
      
        dispatch({ type: OUTWARD_GET_CATEGORY_ATTRIBUTE_SUCCESS, payload: response });
        return response; 
      } catch (error) {
        dispatch({ type: OUTWARD_GET_CATEGORY_ATTRIBUTE_REQUEST, error: error.message });
        return Promise.reject(error); 
      }
    };
  };